// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { DashboardOutlined, ExploreOutlined, PersonOutlined } from '@mui/icons-material';

// type
import { NavItemType } from '../types/menu';
import { useMemo } from 'react';
import { DeepReadonly } from '../types/DeepReadonly';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const useDashboardMenuItems = (): DeepReadonly<NavItemType> =>
	useMemo(
		() => ({
			id: 'dashboard',
			type: 'group',

			children: [
				{
					id: 'dashboardPage',
					title: <FormattedMessage id={'menu.dashboard'} />,
					type: 'item',
					url: '/dashboard',
					icon: DashboardOutlined,
					isActive: (location) => location.pathname.startsWith('/dashboard'),
				},
				{
					id: 'journey',
					title: <FormattedMessage id={'menu.journey'} />,
					type: 'item',
					url: '/journeys',
					icon: ExploreOutlined,
					isActive: (location) => location.pathname.startsWith('/journeys'),
				},
				{
					id: 'personas',
					title: <FormattedMessage id={'menu.personas'} />,
					type: 'item',
					url: '/personas',
					icon: PersonOutlined,
					isActive: (location) => location.pathname.startsWith('/personas'),
				},
			],
		}),
		[],
	);

export { useDashboardMenuItems };
